import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m184.3 160.2-25.4-25.3c8.2-12.7 12.9-27.7 12.9-43.9 0-44.8-36.2-81-80.9-81S10 46.3 10 91c0 44.8 36.2 81 80.9 81 16.2 0 31.3-4.8 44-13l25.3 25.3c7.2 7.2 18.4 7.6 25.1 1 6.6-6.6 6.2-17.9-1-25.1zm-93.4-15.1c-29.8 0-54-24.2-54-54s24.1-54 54-54 54 24.2 54 54c-.1 29.8-24.3 54-54 54z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}